import React from "react";
import logo from '../assests/logo.svg';
import { Link } from 'react-router-dom';
import Input from "./Input";

const Footer = () => {
  return (
    <div className="">
      {/* Footer */}
      <footer className="bg-[#1C97D4] text-white pt-16 pb-4 border-t-8 border-blue-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div>
              <h3 className="font-bold mb-4 footer_heading text-2xl">Markets</h3>
              <ul className="text-blue-100 font-thin">
                <Link to="/commercial" className="hover:text-white footer_link">Commercial Buildings</Link><br></br>
                <Link to="/industrial" className="hover:text-white footer_link">Industrial/Transportation</Link><br></br>
                <Link to="/food" className="hover:text-white footer_link">Food & Beverage</Link><br></br>
                <Link to="/material" className="hover:text-white footer_link">Industrial</Link><br></br>
                <Link to="/waste" className="hover:text-white footer_link">Water & Waste</Link><br></br>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 footer_heading text-2xl">Products</h3>
              <ul className="space-y-2 text-blue-100">
                <Link to="/aop" className="hover:text-white footer_link">Advanced Oxidation Plasma</Link><br></br>
                {/* <Link to="/fcap" className="hover:text-white footer_link">ultraSORB Chemical Media</Link> */}
                <Link to="/OdorNOX" className="hover:text-white footer_link">odorNOX</Link><br></br>
                <Link to="/ccu" className="hover:text-white footer_link">Corrosion Control Unit</Link><br></br>
                <Link to="/forminox" className="hover:text-white footer_link">smokeNOX Unit</Link><br></br>
                <Link to="/fcap" className="hover:text-white footer_link">Falcon-S</Link><br></br>
                <Link to="/fsap" className="hover:text-white footer_link">Falcon-C</Link><br></br>
                <Link to="/vap" className="hover:text-white footer_link">Virusheild Air Purifier</Link><br></br>  
                <Link to="/gap" className="hover:text-white footer_link">Germinox</Link><br></br>
                <Link to="/cf" className="hover:text-white footer_link">CBR Filter</Link><br></br>
                <Link to="/ef" className="hover:text-white footer_link">ESP Filter</Link><br></br>



              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 footer_heading text-2xl">Technologies</h3>
              <ul className="space-y-2 text-blue-100">
                <Link to="/technology#section1" className="hover:text-white footer_link">nanoX® Technology</Link><br></br>
                <Link to="/technology#section2" className="hover:text-white footer_link">plasmOX® Technology</Link><br></br>
                <Link to="/technology#section3" className="hover:text-white footer_link">ultraSORB® Technology</Link><br></br>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 footer_heading text-2xl">Company</h3>
              <ul className="space-y-2 text-blue-100">
                <Link to="/about-us" className="hover:text-white footer_link">About Us</Link>
              </ul>


            </div>
            <div>

              <div className="">
                <h3 className="font-bold mb-4 footer_heading text-2xl">Contact Us</h3>
                <ul className="space-y-2 text-blue-100">

                  <li className="flex items-center space-x-2 text-sm">
                    <img src="./phone-white.svg" alt="Mail Icon" className="w-4 h-4" />
                    <a href="mailto:info@ultrapureindia.in" className="text-blue-100">info@ultrapureindia.in</a>
                  </li>

                  <li className="flex items-center space-x-2 text-sm">
                    <img src="./mail-white.svg" alt="Phone Icon" className="w-4 h-4" />
                    <a href="tel:1800110050" className="text-blue-100">1800-1100-50</a>
                  </li>

                </ul>

              </div>

              <div className="mt-6">
                <h3 className="font-bold mb-4 footer_heading text-2xl">Follow Us</h3>
                <div className="flex space-x-4">
                  <a target="_blank" href="https://www.linkedin.com/company/ultrapureindia"><img src="./linked.png"></img></a>
                  <a target="_blank" href="https://wa.me/7428534141"><img src="./whatsapp.png"></img></a>
                  <a target="_blank" href="https://www.facebook.com/ultrapureindia"><img src="./facbook.png"></img></a>
                  {/* <a target="_blank" href="https://www.facebook.com/ultrapureindia"><img src="./twitter.png"></img></a> */}
                  <a target="_blank" href="https://www.instagram.com/ultrapure_india/"><img src="./instagram.png"></img></a>


                </div>
              </div>
            </div>
          </div>

          <div className=" border-blue-400 mt-12 py-3">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0 px-4 py-6 lg:py-0">
              <img src="./logo_white.png" width={250} className="w-40 md:w-[250px]" alt="UltraPure Logo" />
              <p className="text-blue-100 text-xs text-center md:text-right">
               <a href="https://codecups.in/" target="_blank"> © 2025 UltraPure. All rights reserved. <br />
                Designed and Developed By Codecups</a>
              </p>
            </div>

          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;